var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ActivityItemTask__Component" }, [
    _vm.isOpen
      ? _c("div", { staticClass: "ActivityItemTask__Component__Edit" }, [
          _c("div", { staticClass: "NewTask__Component__Attributes" }, [
            _c(
              "div",
              { staticClass: "Field ml-6" },
              [
                _c("FieldInlineText", {
                  attrs: {
                    "hide-hover": true,
                    label: "שם עיריה",
                    clearable: false,
                    filterable: false,
                    readOnly: true
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.Name,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "Name", $$v)
                    },
                    expression: "model.Name"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "Field ml-6" },
              [
                _c("FieldInlineText", {
                  attrs: {
                    "hide-hover": true,
                    label: "כתובת",
                    clearable: false,
                    filterable: false,
                    changeOnBlur: true
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.Address,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "Address", $$v)
                    },
                    expression: "model.Address"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "Field ml-6" },
              [
                _c("FieldInlineSelect", {
                  attrs: {
                    "hide-hover": true,
                    label: 'חתימת עו"ד',
                    clearable: false,
                    filterable: false,
                    options: [
                      { Value: true, Text: "צריך" },
                      { Value: false, Text: "לא צריך" }
                    ]
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.NeedLawyerSign,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "NeedLawyerSign", $$v)
                    },
                    expression: "model.NeedLawyerSign"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "Field ml-6" },
              [
                _c("FieldInlineSelect", {
                  attrs: {
                    "hide-hover": true,
                    label: ' חתימת עו"ד לעובד',
                    clearable: false,
                    filterable: false,
                    options: [
                      { Value: true, Text: "צריך" },
                      { Value: false, Text: "לא צריך" }
                    ]
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.NeedLawyerSignForDriver,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "NeedLawyerSignForDriver", $$v)
                    },
                    expression: "model.NeedLawyerSignForDriver"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "Field ml-6" },
              [
                _c("FieldInlineText", {
                  attrs: {
                    "hide-hover": true,
                    label: "אימייל להסבה",
                    clearable: false,
                    filterable: false,
                    changeOnBlur: true
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.TransferEmail,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "TransferEmail", $$v)
                    },
                    expression: "model.TransferEmail"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "Field ml-6" },
              [
                _c("FieldInlineText", {
                  attrs: {
                    "hide-hover": true,
                    label: "אימייל להסבה תייר",
                    clearable: false,
                    filterable: false,
                    changeOnBlur: true
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.TouristTransferEmail,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "TouristTransferEmail", $$v)
                    },
                    expression: "model.TouristTransferEmail"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "Field ml-6" },
              [
                _c("FieldInlineText", {
                  attrs: {
                    "hide-hover": true,
                    label: "לינק לתשלום",
                    clearable: false,
                    filterable: false,
                    changeOnBlur: true
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.PaymentUrl,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "PaymentUrl", $$v)
                    },
                    expression: "model.PaymentUrl"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "Field ml-6" },
              [
                _c("FieldInlineSelect", {
                  attrs: {
                    "hide-hover": true,
                    label: "TransferBotId",
                    clearable: true,
                    filterable: false,
                    optionsAsync: _vm.getTransferBotIds
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.TransferBotId,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "TransferBotId", $$v)
                    },
                    expression: "model.TransferBotId"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "Field ml-6" },
              [
                _c("FieldInlineText", {
                  attrs: {
                    "hide-hover": true,
                    label: "TransferBotAuthorityId",
                    clearable: false,
                    filterable: false,
                    changeOnBlur: true
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.TransferBotAuthorityId,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "TransferBotAuthorityId", $$v)
                    },
                    expression: "model.TransferBotAuthorityId"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "Field ml-6",
                class: { "field-required": _vm.rePortIdError }
              },
              [
                _c("FieldInlineText", {
                  attrs: {
                    "hide-hover": true,
                    label: "מספר עירייה בריפורט (פרימיום ואונליין)",
                    clearable: false,
                    filterable: false,
                    type: "number",
                    changeOnBlur: true
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.RePortId,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "RePortId", $$v)
                    },
                    expression: "model.RePortId"
                  }
                }),
                _vm.rePortIdError
                  ? _c("p", { staticClass: "field-error" }, [
                      _vm._v(_vm._s(_vm.rePortIdError))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "days-groups-wrapper" }, [
              _c("div", { staticClass: "days-group" }, [
                _c(
                  "div",
                  { staticClass: "Field ml-6 field-with-tooltip" },
                  [
                    _c(
                      "b-tooltip",
                      {
                        staticClass: "field-tooltip",
                        attrs: {
                          label:
                            "מספר ימים מינימלי לאימות. אם תאריך האימות האחרון שהתקבל מהרשות עבר את הסף – הדוח יכול לצאת לשליחה גם לפני שהתקופה השנייה הסתיימה.",
                          position: "is-top",
                          multilined: ""
                        }
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            icon: "information",
                            size: "is-small",
                            type: "is-info"
                          }
                        })
                      ],
                      1
                    ),
                    _c("FieldInlineText", {
                      attrs: {
                        "hide-hover": true,
                        label:
                          "ימי השהית שליחה (תקופה ראשונה: מספר ימים מינימלי לאימות)",
                        clearable: false,
                        filterable: false,
                        type: "number",
                        changeOnBlur: true
                      },
                      on: { onChange: _vm.onChange },
                      model: {
                        value: _vm.model.SuspensionPeriodInDays,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "SuspensionPeriodInDays", $$v)
                        },
                        expression: "model.SuspensionPeriodInDays"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "Field ml-6 field-with-tooltip",
                    class: {
                      "field-required":
                        _vm.model.SecondSuspensionPeriodInDays === null ||
                        _vm.model.SecondSuspensionPeriodInDays === undefined ||
                        _vm.model.SecondSuspensionPeriodInDays === ""
                    }
                  },
                  [
                    _c(
                      "b-tooltip",
                      {
                        staticClass: "field-tooltip",
                        attrs: {
                          label:
                            "דוח יוצא מהשהיה ונשלח רק אם עברו מספיק ימים מאז הוצאת הדוח.",
                          position: "is-top",
                          multilined: ""
                        }
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            icon: "information",
                            size: "is-small",
                            type: "is-info"
                          }
                        })
                      ],
                      1
                    ),
                    _c("FieldInlineText", {
                      attrs: {
                        "hide-hover": true,
                        label: "ימי השהית שליחה (תקופה שנייה: זמן מקבלת הדוח )",
                        clearable: false,
                        filterable: false,
                        type: "number",
                        changeOnBlur: true
                      },
                      on: { onChange: _vm.onChange },
                      model: {
                        value: _vm.model.SecondSuspensionPeriodInDays,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model,
                            "SecondSuspensionPeriodInDays",
                            $$v
                          )
                        },
                        expression: "model.SecondSuspensionPeriodInDays"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "days-group" }, [
                _c(
                  "div",
                  { staticClass: "Field ml-6" },
                  [
                    _c("FieldInlineText", {
                      attrs: {
                        "hide-hover": true,
                        label: "ימי המתנה לתשובה להסבה",
                        clearable: false,
                        filterable: false,
                        changeOnBlur: true
                      },
                      on: { onChange: _vm.onChange },
                      model: {
                        value: _vm.model.TransferClarificationDays,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "TransferClarificationDays", $$v)
                        },
                        expression: "model.TransferClarificationDays"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "Field ml-6" },
                  [
                    _c("FieldInlineText", {
                      attrs: {
                        "hide-hover": true,
                        label: "ימי המתנה לתשובה להסבת תייר",
                        clearable: false,
                        filterable: false,
                        changeOnBlur: true
                      },
                      on: { onChange: _vm.onChange },
                      model: {
                        value: _vm.model.TouristTransferClarificationDays,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model,
                            "TouristTransferClarificationDays",
                            $$v
                          )
                        },
                        expression: "model.TouristTransferClarificationDays"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "Field ml-6" },
              [
                _c("FieldInlineTextArea", {
                  attrs: {
                    "hide-hover": true,
                    label: "הערות",
                    changeOnBlur: true
                  },
                  on: { onChange: _vm.onChange },
                  model: {
                    value: _vm.model.Notes,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "Notes", $$v)
                    },
                    expression: "model.Notes"
                  }
                })
              ],
              1
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }